/* unplugin-vue-components disabled */import { render } from "./PBLoader.vue?vue&type=template&id=1bdba0b5"
const script = {}

import "./PBLoader.vue?vue&type=style&index=0&id=1bdba0b5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__